
//const xlsaccept = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel';
import { formatJsonDataset as fjd } from "../../components/renderers";
import { formatJsonLocation as fjl } from "../../components/renderers";


export const financeconfig = {
    contribution: {
        service: {
            name: 'contribution',
            title: 'Contributions',
            key: 'rid',
            num: true,
            pageMode: 'remote',
            fields: ['pid', 'rid', 'mno', 'sno', 'mti', 'mtc', 'mpi', 'mpc', 'mph', 'msi', 'msc', 'bat', 'ssi', 'ssc', 'sts', 'ast', 'stp'],
            params: { mno: 'MeterNo', sno: 'StsNo', mti: 'Type', mpi: 'Phase', msi: 'StatusId', bat: 'Batch', ssi: 'StateId', sts: 'Status' },
            grid: [['cdt', 'Contribution Date'], ['amt', 'Amount'], ['tpn', 'Type'], ['rfn', 'Reference'], ['stp', 'Stamp']],
            bar: { pag: true, btn: ['view'] },
            menu: { mnu: [{ t: 'Meter', v: 'mno' }, { t: 'STS', v: 'sno' }], def: 'mno' },
            eform: [
                { id: 'cdt', label: 'Contribution Date', type: 'df', req: 1, ops: {} },
                { id: 'amt', label: 'Amount', type: 'nf', req: 1, ops: {} },
                { id: 'dsc', label: 'Description', type: 'ta', req: 0, ops: {} },
                { id: 'tei', label: 'Event', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'event' } },
                { id: 'tpi', label: 'Contribution Type', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'contributiontype' } },
                { id: 'exi', label: 'Extra Info', type: 'jf', req: 0, ops: {} },
                { id: 'sts', label: 'Record Status', type: 'fa', req: 0, ops: {}, cp: { t: 'lcs', s: 'status' } },
            ],
        },
        create: true,
        actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete', view: 'View' },
        panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' },
        formatters: { grid: { geo: fjl, exi: fjd } }
    },
    pledge: {
        service: {
            name: 'pledge',
            title: 'Pledges',
            key: 'rid',
            num: true,
            pageMode: 'remote',
            fields: ['pid', 'rid', 'mno', 'sno', 'mti', 'mtc', 'mpi', 'mpc', 'mph', 'msi', 'msc', 'bat', 'ssi', 'ssc', 'sts', 'ast', 'stp'],
            params: { mno: 'MeterNo', sno: 'StsNo', mti: 'Type', mpi: 'Phase', msi: 'StatusId', bat: 'Batch', ssi: 'StateId', sts: 'Status' },
            grid: [['pdt', 'Pledge Date'], ['itm', 'Item'], ['amt', 'Amount Pledged'], ['pai', 'Paid'], ['due', 'Due'], ['rfn', 'Reference'], ['stp', 'Stamp']],
            bar: { pag: true, btn: ['view'] },
            menu: { mnu: [{ t: 'Meter', v: 'mno' }, { t: 'STS', v: 'sno' }], def: 'mno' },
            eform: [
                { id: 'pdt', label: 'Pledge Date', type: 'df', req: 1, ops: {} },
                { id: 'itm', label: 'Name', type: 'tf', req: 1, ops: {} },
                { id: 'dsc', label: 'Description', type: 'tf', req: 0, ops: {} },
                { id: 'amt', label: 'Amount', type: 'nf', req: 1, ops: {} },
                { id: 'pai', label: 'Amount Paid', type: 'nf', req: 1, ops: {} },
                { id: 'due', label: 'Due Date', type: 'df', req: 1, ops: {} },
                { id: 'psi', label: 'Item Status', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'pledgestatus' } },
                // { id: 'pgi', label: 'Group', type: 'fa', req: 0, ops: {}, cp: { t: 'bcs', s: 'groups' } },
                { id: 'mid', label: 'Member', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'members' } },
                // { id: 'rfn', label: 'Reference No', type: 'tf', req: 1, ops: {} },
                { id: 'exi', label: 'Extra Info', type: 'jf', req: 0, ops: {} },
                { id: 'sts', label: 'Record Status', type: 'fa', req: 0, ops: {}, cp: { t: 'lcs', s: 'status' } },
            ],
        },
        create: true,
        actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete', view: 'View' },
        panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' },
        formatters: { grid: { geo: fjl, exi: fjd } }
    },
    specialoffering: {
        service: {
            name: 'specialoffering',
            title: 'Special Offering',
            key: 'rid',
            num: true,
            pageMode: 'remote',
            fields: ['pid', 'rid', 'mno', 'sno', 'mti', 'mtc', 'mpi', 'mpc', 'mph', 'msi', 'msc', 'bat', 'ssi', 'ssc', 'sts', 'ast', 'stp'],
            params: { mno: 'MeterNo', sno: 'StsNo', mti: 'Type', mpi: 'Phase', msi: 'StatusId', bat: 'Batch', ssi: 'StateId', sts: 'Status' },
            grid: [['pdt', 'Special Offering Date'], ['itm', 'Item'], ['amt', 'Amount'],['trn', 'Member'], ['rfn', 'Reference'], ['stp', 'Stamp']],
            bar: { pag: true, btn: ['view'] },
            menu: { mnu: [{ t: 'Meter', v: 'mno' }, { t: 'STS', v: 'sno' }], def: 'mno' },
            eform: [
                { id: 'pdt', label: 'Special Offering Date', type: 'df', req: 1, ops: {} },
                { id: 'itm', label: 'Name', type: 'tf', req: 1, ops: {} },
                { id: 'dsc', label: 'Description', type: 'tf', req: 0, ops: {} },
                { id: 'amt', label: 'Amount', type: 'nf', req: 1, ops: {} },

                { id: 'psi', label: 'Item Status', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'specialofferingstatus' } },
                // { id: 'pgi', label: 'Group', type: 'fa', req: 0, ops: {}, cp: { t: 'bcs', s: 'groups' } },
                { id: 'mid', label: 'Member', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'members' } },
                // { id: 'rfn', label: 'Reference No', type: 'tf', req: 1, ops: {} },
                { id: 'exi', label: 'Extra Info', type: 'jf', req: 0, ops: {} },
                { id: 'sts', label: 'Record Status', type: 'fa', req: 0, ops: {}, cp: { t: 'lcs', s: 'status' } },
            ],
        },
        create: false,
        actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete', view: 'View' },
        panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' },
        formatters: { grid: { geo: fjl, exi: fjd } }
    },
    donation: {
        service: {
            name: 'donation',
            title: 'Donations',
            key: 'rid',
            num: true,
            pageMode: 'remote',
            fields: ['pid', 'rid', 'mno', 'sno', 'mti', 'mtc', 'mpi', 'mpc', 'mph', 'msi', 'msc', 'bat', 'ssi', 'ssc', 'sts', 'ast', 'stp'],
            params: { mno: 'MeterNo', sno: 'StsNo', mti: 'Type', mpi: 'Phase', msi: 'StatusId', bat: 'Batch', ssi: 'StateId', sts: 'Status' },
            grid: [['ddt', 'Donation Date'], ['itm', 'Item'], ['amt', 'Amount'], ['dsc', 'Description'], ['rfn', 'Reference'], ['stp', 'Stamp']],
            bar: { pag: true, btn: ['view'] },
            menu: { mnu: [{ t: 'Meter', v: 'mno' }, { t: 'STS', v: 'sno' }], def: 'mno' },
            eform: [
                { id: 'ddt', label: 'Donation Date', type: 'df', req: 1, ops: {} },
                { id: 'itm', label: 'Name', type: 'tf', req: 1, ops: {} },
                { id: 'dsc', label: 'Description', type: 'ta', req: 0, ops: {} },
                { id: 'amt', label: 'Amount', type: 'nf', req: 1, ops: {} },
                { id: 'dsi', label: 'Donation Status', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'donationstatus' } },
                { id: 'dgi', label: 'Group', type: 'fa', req: 0, ops: {}, cp: { t: 'bcs', s: 'groups' } },
                { id: 'dby', label: 'Donated By', type: 'tf', req: 1, ops: {}},
                { id: 'exi', label: 'Extra Info', type: 'jf', req: 0, ops: {} },
                { id: 'sts', label: 'Record Status', type: 'fa', req: 0, ops: {}, cp: { t: 'lcs', s: 'status' } },
            ],
        },
        create: true,
        actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete', view: 'View' },
        panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' },
        formatters: { grid: { geo: fjl, exi: fjd } }
    },
    dues: {
        service: {
            name: 'dues',
            title: 'Dues',
            key: 'rid',
            num: true,
            pageMode: 'remote',
            fields: ['pid', 'rid', 'mno', 'sno', 'mti', 'mtc', 'mpi', 'mpc', 'mph', 'msi', 'msc', 'bat', 'ssi', 'ssc', 'sts', 'ast', 'stp'],
            params: { mno: 'MeterNo', sno: 'StsNo', mti: 'Type', mpi: 'Phase', msi: 'StatusId', bat: 'Batch', ssi: 'StateId', sts: 'Status' },
            grid: [['mfn', 'Name'],  ['amt', 'Amount'],['pai', 'Amount Paid'],['lft', 'Amount Left'],  ['rfn', 'Reference'],['npd', 'Next Payment Date'], ['stp', 'Stamp']],
            bar: { pag: true, btn: ['view'] },
            menu: { mnu: [{ t: 'Meter', v: 'mno' }, { t: 'STS', v: 'sno' }], def: 'mno' },
            eform: [
                { id: 'mfn', label: 'Name', type: 'tf', },
                { id: 'amt', label: 'Amount', type: 'nf',},
                { id: 'pai', label: 'Amount Paid', type: 'nf', req: 0, ops: {} },
                { id: 'lft', label: 'Amount Left', type: 'nf', req: 1, ops: {} },
                { id: 'rfn', label: 'Reference no', type: 'tf', req: 1,  },
                { id: 'npd', label: 'Next Payment Date', type: 'df', req: 0,},
                { id: 'sts', label: 'Record Status', type: 'fa', req: 0, ops: {}, cp: { t: 'lcs', s: 'status' } },
            ],
        },
        create: false,
        actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete', view: 'View' },
        panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' },
        formatters: { grid: { geo: fjl, exi: fjd } }
    },
    duestype: {
        service: {
            name: 'duestype',
            title: 'Dues types',
            key: 'rid',
            num: true,
            pageMode: 'remote',
            fields: ['pid', 'rid', 'mno', 'sno', 'mti', 'mtc', 'mpi', 'mpc', 'mph', 'msi', 'msc', 'bat', 'ssi', 'ssc', 'sts', 'ast', 'stp'],
            params: { mno: 'MeterNo', sno: 'StsNo', mti: 'Type', mpi: 'Phase', msi: 'StatusId', bat: 'Batch', ssi: 'StateId', sts: 'Status' },
            grid: [['nam', 'Name'],  ['amt', 'Amount'],['shc', 'Short code'],['dsc', 'Description'],  ['stp', 'Stamp']],
            bar: { pag: true, btn: ['view'] },
            menu: { mnu: [{ t: 'Meter', v: 'mno' }, { t: 'STS', v: 'sno' }], def: 'mno' },
            eform: [
                { id: 'nam', label: 'Name', type: 'tf',req:1,ops:{} },
                { id: 'amt', label: 'Amount', type: 'nf',req:1,ops:{}},
                { id: 'shc', label: 'Short code', type: 'tf', req: 1, ops: {} },
                { id: 'dsc', label: 'Description', type: 'ta', req: 0, ops: {} },
                { id: 'sts', label: 'Record Status', type: 'fa', req: 0, ops: {}, cp: { t: 'lcs', s: 'status' } },
            ],
        },
        create: true,
        actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete', view: 'View' },
        panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' },
        formatters: { grid: { geo: fjl, exi: fjd } }
    },
    massintent: {
        service: {
            name: 'massintent',
            title: 'Mass Intentions',
            key: 'rid',
            num: true,
            pageMode: 'remote',
            fields: ['pid', 'rid', 'mno', 'sno', 'mti', 'mtc', 'mpi', 'mpc', 'mph', 'msi', 'msc', 'bat', 'ssi', 'ssc', 'sts', 'ast', 'stp'],
            params: { mno: 'MeterNo', sno: 'StsNo', mti: 'Type', mpi: 'Phase', msi: 'StatusId', bat: 'Batch', ssi: 'StateId', sts: 'Status' },
            grid: [['ind', 'Intent Date'], ['rno', 'Refno'], ['amt', 'Amount'], ['msn', 'Mass'], ['mfn', 'Member First Name'], ['mln', 'Member Last Name']],
            bar: { pag: true, btn: ['view'] },
            menu: { mnu: [{ t: 'Meter', v: 'mno' }, { t: 'STS', v: 'sno' }], def: 'mno' },
            eform: [
                { id: 'ind', label: 'Intent Date', type: 'df', },
                { id: 'rno', label: 'Refno', type: 'tf', req: 1, ops: {} },
                { id: 'dsc', label: 'Description', type: 'ta', req: 0, ops: {} },
                { id: 'amt', label: 'Amount', type: 'nf', req: 1, ops: {} },
                { id: 'msn', label: 'Mass', type: 'fa'},
                { id: 'mfn', label: 'Requested By', type: 'tf', req: 1, ops: {}},
                { id: 'mln', label: 'Requested By', type: 'tf', req: 1, ops: {}},
                { id: 'exi', label: 'Extra Info', type: 'jf', req: 0, ops: {} },
                { id: 'sts', label: 'Record Status', type: 'fa', req: 0, ops: {}, cp: { t: 'lcs', s: 'status' } },
            ],
        },
        create: false,
        actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete', view: 'View' },
        panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' },
        formatters: { grid: { geo: fjl, exi: fjd } }
    },
    allocation: {
        service: {
            name: 'allocation',
            title: 'Allocations',
            key: 'rid',
            num: true,
            pageMode: 'remote',
            fields: ['pid', 'rid', 'mno', 'sno', 'mti', 'mtc', 'mpi', 'mpc', 'mph', 'msi', 'msc', 'bat', 'ssi', 'ssc', 'sts', 'ast', 'stp'],
            params: { mno: 'MeterNo', sno: 'StsNo', mti: 'Type', mpi: 'Phase', msi: 'StatusId', bat: 'Batch', ssi: 'StateId', sts: 'Status' },
            grid: [['cdt', 'Allocation Date'], ['amt', 'Amount'], ['tpn', 'Type'], ['rfn', 'Reference'], ['stp', 'Stamp']],
            bar: { pag: true, btn: ['view'] },
            menu: { mnu: [{ t: 'Meter', v: 'mno' }, { t: 'STS', v: 'sno' }], def: 'mno' },
            eform: [
                { id: 'mno', label: 'meter No', type: 'rf', req: 1, ops: {} },
                { id: 'sno', label: 'STS No', type: 'rf', req: 1, ops: {} },
                { id: 'mtc', label: 'Type', type: 'rf', req: 1, ops: {} },
                { id: 'mph', label: 'Phase', type: 'rf', req: 1, ops: {} },
                { id: 'msc', label: 'Status', type: 'rf', req: 1, ops: {} },
                { id: 'bat', label: 'Batch', type: 'rf', req: 1, ops: {} },
                { id: 'ssc', label: 'State', type: 'rf', req: 1, ops: {} },
                { id: 'sts', label: 'Record Status', type: 'fa', req: 0, ops: {}, cp: { t: 'lcs', s: 'status' } },
            ],
        },
        create: true,
        actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete', view: 'View' },
        panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' },
        formatters: { grid: { geo: fjl, exi: fjd } }
    },
    bankaccounts: {
        service: {
            name: 'bankaccounts',
            title: 'Bank Accounts',
            key: 'rid',
            num: true,
            pageMode: 'remote',
            fields: ['pid', 'rid', 'mno', 'sno', 'mti', 'mtc', 'mpi', 'mpc', 'mph', 'msi', 'msc', 'bat', 'ssi', 'ssc', 'sts', 'ast', 'stp'],
            params: { mno: 'MeterNo', sno: 'StsNo', mti: 'Type', mpi: 'Phase', msi: 'StatusId', bat: 'Batch', ssi: 'StateId', sts: 'Status' },
            grid: [['nam', 'Name'], ['acn', 'Account No'], ['bbn', 'Bank'], ['soc', 'Sort'], ['swc', 'Swift'], ['ibn', 'Iban'], ['ast', 'Status'], ['stp', 'Stamp']],
            bar: { pag: true, btn: ['view'] },
            menu: { mnu: [{ t: 'Meter', v: 'mno' }, { t: 'STS', v: 'sno' }], def: 'mno' },
            eform: [
                { id: 'mno', label: 'meter No', type: 'rf', req: 1, ops: {} },
                { id: 'sno', label: 'STS No', type: 'rf', req: 1, ops: {} },
                { id: 'mtc', label: 'Type', type: 'rf', req: 1, ops: {} },
                { id: 'mph', label: 'Phase', type: 'rf', req: 1, ops: {} },
                { id: 'msc', label: 'Status', type: 'rf', req: 1, ops: {} },
                { id: 'bat', label: 'Batch', type: 'rf', req: 1, ops: {} },
                { id: 'ssc', label: 'State', type: 'rf', req: 1, ops: {} },
                { id: 'sts', label: 'Record Status', type: 'fa', req: 0, ops: {}, cp: { t: 'lcs', s: 'status' } },
            ],
        },
        create: true,
        actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete', view: 'View' },
        panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' },
        formatters: { grid: { geo: fjl, exi: fjd } }
    },

}
